const messages = {
  title: "Prodajne promocije",
  desc: "Aktivno koristite naše prodajne promocije sa vašim klijentima. Naravno, možete ponuditi klijentima obe promocije. Pročitajte više o Garanciji guma i Drive Our Best u nastavku.",
  participation: {
    title: "Zatražite vaše učestvovanje sada",
    desc: "Da li biste željeli implementirati jednu ili više naših promocija u vašoj prodavnici? Tada možete zatražiti ovde vaše učestvovanje. Vaša kompanija će biti aktivirana za promocije i primiće promotivne materijale u roku od 4 nedelje za vašu prodajnu kampanju.<br/><br/>Napravite vaš izbor:",
    request: "ZATRAŽITE UČESTVOVANJE",
    success: "Hvala vam, vaš zahtev je poslat",
  },
};
export default {
  messages,
};
